module.exports = __webpack_public_path__ + "img/title-bg2.f81cedb6.png";